const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1'

export let config

export async function setConfig() {
  if (config) {
    return config
  }
  const response = isLocal ? await fetch('/config.json') : await fetch('/config.js')
  const { baseDomain, environment, googleMapsKey, recaptchaSiteKey } = await response.json()
  const alias = getAlias(baseDomain)
  const base_url = baseDomain.replace('{0}', alias)
  const storeEnvironment = environment.replace(/^aws-/, '')

  config = {
    environment,
    alias,
    base_url,
    // Locally, /api images go through the Vite proxy so the auth cookie stays first-party.
    image_base_url: isLocal ? window.location.origin : base_url,
    api_url: isLocal ? '/api/' : `${base_url}/api/`,
    store_url:
      storeEnvironment === 'prod' ? 'https://store.quotila.com/' : `https://store.${storeEnvironment}.quotila.com/`,
    googleMapsKey,
    recaptchaSiteKey
  }
  return config
}

function getAlias(baseDomain) {
  let url
  if (isLocal) {
    const { hostname } = new URL(baseDomain)
    url = hostname
  } else {
    url = window.location.hostname
  }
  return url.split('.')[0]
}
